module.exports = __webpack_public_path__ + "static/media/chats-inactive.33c1903d.svg";